import {IEtfAssetBackend, IEtfBackend, IEtfDocumentBackend} from "./etf.model";

const apiBaseUrl = process.env.REACT_APP_INTEGRATION_ETFS_URIBASE!;

export interface IEtfService {
	info(ticker: string): Promise<IEtfBackend>;
	documents(ticker: string): Promise<IEtfDocumentBackend[]>;
	assets(ticker: string): Promise<{data: IEtfAssetBackend[], isDataTruncated: boolean}>;
}

export class EtfServiceImpl implements IEtfService {
	async info(ticker: string): Promise<IEtfBackend> {
		const response = await fetch(`${apiBaseUrl}/${ticker}/info`);
		const responseJson = await response.json();
		responseJson.tradingStartDate = new Date(Date.parse(responseJson.tradingStartDate))
		return responseJson;
	}
	async documents(ticker: string): Promise<IEtfDocumentBackend[]> {
		const response = await fetch(`${apiBaseUrl}/${ticker}/documents`);
		const responseJson = await response.json();
		return responseJson.map((x: any) => (<IEtfDocumentBackend>{ ...x, date: new Date(Date.parse(x.date)) }));
	}
	async assets(ticker: string): Promise<{data: IEtfAssetBackend[], isDataTruncated: boolean}> {
		const response = await fetch(`${apiBaseUrl}/${ticker}/assets`);
		return await response.json();
	}
}